import * as getters from "../../baseQuestion/searchableStaticDDL/store/getters";
import * as mutations from "../../baseQuestion/searchableStaticDDL/store/mutations";
import * as actions from "../../baseQuestion/searchableStaticDDL/store/actions";
import { state as base_state } from "../../baseQuestion/searchableStaticDDL/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_awards",
			options: [
				{
					value: "HSH",
					text: "High School Honors - Academics"
				},
				{
					value: "NHS",
					text: "National Honor Society"
				},
				{
					value: "NMF",
					text: "National Merit Finalist"
				},
				{
					value: "NMSF",
					text: "National Merit Semi-Finalist"
				},
				{
					value: "OTH",
					text: "Honors - Other"
				}
			]
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
